<script setup>
import { computed } from "vue";
import { useStore } from "@/state/store";
const store = useStore();

const user = computed(() => store.getP('user'));

// Get initials (first 2 letters)
const initials = computed(() => {
  if (!user.value?.login) return '';
  return user.value.login.trim().slice(0, 2).toUpperCase();
});

// Simple hash to color
function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase();
  return "#" + "00000".substring(0, 6 - c.length) + c;
}

const bgColor = computed(() => stringToColor(initials.value));
</script>

<template>
  <div
    class="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold"
    style="width: 35px; height: 35px;font-size: 14px;"
    :style="{ backgroundColor: bgColor }"
  >
    {{ initials }}
  </div>
</template>